import { temAcesso } from '@/shared/auth/temAcesso'

const Pleitos = () => import('./Pleitos.vue')
const Detalhes = () => import('./PleitosDetalhar.vue')
const PleitoForm = () => import('../componentes/PleitoForm.vue')

export default {
    path: 'pleitos/uai',
    name: 'Pleitos_Uai',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('PLEITOS-UAI-00')) {
            next()
        }
    },
    children: [
        {
            path: '/pleitos/uai',
            name: 'Pleitos_Uai',
            component: Pleitos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-UAI-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/uai/:pleitoId',
            name: 'Pleitos_Uai_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-UAI-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/inserir',
            name: 'Pleitos_Uai_Inserir',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-UAI-01')) {
                    next();
                }
            }
        },
        {
            path: '/pleitos/atualizar/:pleitoId',
            name: 'Pleitos_Uai_Atualizar',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-UAI-01')) {
                    next();
                }
            }
        }, 
    ]
}
